import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { AssetTypeSettingsAttachmentsViewTopBar } from "./TopBar"

export const assetTypeAttachmentsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: AssetTypeSettingsAttachmentsViewTopBar,
}
